const levelsMapper = (levelResponse) => ({
  id: levelResponse.id,
  name: levelResponse.displayName,
  selected: false,
  value: levelResponse.id,
});

export default levelsMapper;
